import React, { useState, useEffect } from "react";
import FilterCalendarDeadlines from "./filterCalendar";
import moment from "moment";
import ListDeadlines from "./listDeadlines";
import DeadlinesCards from "./deadlinesCards";
import { useSelector } from "react-redux";
import DateCell from "./dateCell";
import { Calendar as CalendarAntd } from "antd";
import AnalyticsChart from "../../analytics/index";
import { Spin } from "antd";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import {
  getFirstDateOfMonth,
  getLastDateOfMonth
} from "../../../libs/deadlinesUtils";

import {
  FEATURE_TOGGLE_ANALYTICS,
  FEATURE_TOGGLE_DEADLINES_CARD,
  FEATURE_TOGGLE_CASH_FLOW
} from "../../../config";
import CashFlowModal from "../../analytics/cashFlowModal";
import { useNavigate } from "react-router-dom";

const Calendar = props => {
  const {
    dateSelected,
    filterTypeCalendar,
    filtersCalendar,
    filtersList,    
    onChangeDateFilter,
    onDayClick,
    onDayHover,
    resetMonthView,
    selectedDay,
    setFilterList,
    subjectiveMonthView,
    subjectiveMonth,
    toggleArchivedDeadline,
    companySelected,
    prevPath,
    myType,
    customersView,
    classifierCompanySelected,
    scope,
    archived,
    filters,
    setCustomersView,
    companyUuidSelected,
    balanceDetailDialog,
    setBalanceDetailDialog
  } = props;

  const navigate = useNavigate();
  const deadlinesCompany = useSelector(state => state.deadlinesCompany);
  const deadlinesAccountant = useSelector(state => state.deadlinesAccountant);
  const isGettingDeadlines = deadlinesCompany.isGettingDeadlines;
  const tspay = useSelector(state => state.tspay);
  const tspayAccounts = tspay.accounts?.list;
  const isTsPayEnabled = tspay.configStatus?.data?.status === "LINKED" || false;
  const [totalTsPay, setTsPay] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const [showPlaceHolder, setShowPlaceholder] = useState(false);
  const [deadlinesToShow, setDeadlinesToShow] = useState([]);
  const [graph, setGraph] = useState({ display: false, balance: 0 });
  const [
    showPlaceholderAfterOrBefore,
    setShowPlaceholderAfterOrBefore
  ] = useState(false);
  const [monthBefore, setMonthBefore] = useState(false);
  const [monthAfter, setMonthAfter] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    if (customersView === "cashFlow") {
      const firstDayOfMonth = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      const momentDateSelected = moment(dateSelected);
      const isMonthBefore = momentDateSelected.isBefore(firstDayOfMonth);
      setMonthBefore(isMonthBefore);
      let threeMonthAfter = moment().add(2, "M");
      const isMonthAfter = momentDateSelected.isAfter(threeMonthAfter);
      setMonthAfter(isMonthAfter);
      if (isMonthBefore || isMonthAfter) {
        setShowPlaceholderAfterOrBefore(true);
      } else {
        setShowPlaceholderAfterOrBefore(false);
      }
    }
  }, [dateSelected, customersView]);

  useEffect(() => {
    if (customersView === "cashFlow") {
      if (showPlaceholderAfterOrBefore) {
        setShowPlaceholder(false);
      }
    }
  }, [showPlaceHolder]);

  useEffect(() => {
    if (customersView === "cashFlow" && !showPlaceholderAfterOrBefore) {
      if (!localStorage.getItem("objCashFlow")) {
        localStorage.setItem("objCashFlow", JSON.stringify([]));
      }
      const objList = JSON.parse(localStorage.getItem("objCashFlow"));
      const objCompany = objList.filter(el => el.id === companyUuidSelected);
      if (!isTsPayEnabled) {
        let total = 0;

        if (objCompany.length > 0 && objCompany[0]?.available) {
          total += parseFloat(objCompany[0].available);
        }
        if (objCompany.length > 0 && objCompany[0]?.balance) {
          total += parseFloat(objCompany[0].balance);
        }
        if (total === 0) {
          setShowPlaceholder(true);
        } else {
          setGraph({ display: true, balance: total });
        }
      }

      if (objCompany.length === 0) {
        let objRead = JSON.parse(localStorage.getItem("objCashFlow"));
        if (isTsPayEnabled) {
          objRead.push({
            id: companyUuidSelected,
            available: 0,
            lastUpdate: moment()
          });
        } else {
          objRead.push({
            id: companyUuidSelected,
            balance: 0,
            available: 0,
            lastUpdate: moment()
          });
        }
        localStorage.setItem("objCashFlow", JSON.stringify(objRead));
      }
    }
  }, [customersView, showPlaceholderAfterOrBefore]);

  useEffect(() => {
    if (customersView === "cashFlow" && isTsPayEnabled && tspayAccounts) {
      let total = 0;
      tspayAccounts.map(account => {
        if (account.amount) {
          total += account.amount;
        }
        return null;
      });
      setTsPay(total);
    }
  }, [tspayAccounts, customersView]);

  useEffect(() => {
    if (customersView === "cashFlow" && isTsPayEnabled) {
      const objList = JSON.parse(localStorage.getItem("objCashFlow"));
      const objCompany = objList.filter(el => el.id === companyUuidSelected);
      const totalCompany = objCompany[0]
        ? objCompany[0].available
        : 0;
      const balance = parseFloat(totalTsPay) + parseFloat(totalCompany);
      if (totalTsPay && totalTsPay !== 0) {
        setGraph({ display: true, balance: balance });
      }
    }
  }, [totalTsPay, customersView]);

  useEffect(() => {
    if (customersView !== "cashFlow") {
      setGraph({ display: false, balance: 0 });
    }
  }, [customersView]);

  useEffect(() => {
    setDeadlinesToShow(filtersList.activeFilters.length > 0 ? deadlinesAccountant.effectiveOrNot.deadlines : subjectiveMonthView);
  }, [filtersList, deadlinesAccountant, subjectiveMonthView]);

  const goToActuallyOrLatestValidMonth = () => {
    
    let month = moment().month();
    if (monthAfter) {
      month = moment().month() + 2;
    }
    onChangeDateFilter(moment().year(), month);
    localStorage.setItem("calendarFromDate",
      getFirstDateOfMonth(month, moment().year()));
    localStorage.setItem("calendarToDate",
      getLastDateOfMonth(month, moment().year()));
  };

  return (
    <React.Fragment>
      {FEATURE_TOGGLE_DEADLINES_CARD === "true" && (
        <React.Fragment>
          <div
            style={{
              display: "flex",
              widht: "100%",
              marginBottom: "15px",
              marginTop: "20px"
            }}
          >
            <div
              style={{
                flex: "1",
                marginLeft: "23px",
                paddingLeft: 10,
                fontSize: "16px"
              }}
            >
              Pagamenti
            </div>
            <div style={{ flex: "1", marginLeft: "23px", fontSize: "16px" }}>
              Incassi
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginBottom: "20px",
              paddingLeft: 10,
              paddingRight: 10
            }}
          >
            <div style={{ flex: "1" }}>
              <DeadlinesCards
                itemList={["Scaduti", "In scadenza", "Pagati"]}
                className={"deadlineCardPagamenti"}
                deadlines={subjectiveMonth}
              />
            </div>
            <div style={{ flex: "1" }}>
              <DeadlinesCards
                itemList={["Scaduti", "In scadenza", "Incassati"]}
                className={"deadlineCardIncassi"}
                deadlines={subjectiveMonth}
              />
            </div>
          </div>{" "}
        </React.Fragment>
      )}
      <FilterCalendarDeadlines
        filterTypeCalendar={filterTypeCalendar}
        dateSelected={dateSelected}
        onChangeDateFilter={onChangeDateFilter}
        filtersCalendar={filtersCalendar}
        companySelected={companySelected}
        myType={myType}
        setCustomersView={setCustomersView}
        customersView={customersView}
        classifierCompanySelected={classifierCompanySelected}
        balanceDetailDialog={balanceDetailDialog}
        setBalanceDetailDialog={setBalanceDetailDialog}
      />
      <div className="containerWhite containerWhiteDeadlinesCalendar">
        <div className="boxCalendar">
          {customersView === "calendar" && (
            <CalendarAntd
              className={"deadlinesCalendar"}
              onSelect={val => onDayClick(val)}
              value={moment(dateSelected)}
              headerRender={() => null}
              dateFullCellRender={value => (
                <DateCell
                  onDayHover={onDayHover}
                  subjectiveMonthView={subjectiveMonthView}
                  deadlinesToShow={deadlinesToShow}
                  valueDate={value}
                />
              )}
            />
          )}
          {customersView === "graph" &&
            FEATURE_TOGGLE_ANALYTICS === "true" &&
            classifierCompanySelected !== "PERSON" &&
            (isLoading ? (
              <Spin
                indicator={
                  <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
                }
                size="large"
                tip={
                  <span>
                    <FormattedMessage id="generic.loading1" /> <br /> <FormattedMessage id="generic.loading2" />
                  </span>
                }
                style={{
                  fontSize: "20px",
                  width: "100%",
                  height: "500px",
                  paddingTop: "200px"
                }}
              />
            ) : (
              <AnalyticsChart
                classChart=""
                idDivForChart="analyticsView-chart-customer-deadlines"
                kpiName="DeadlinesInMonthChart"
                metamodel={true}
                addParameter={{
                  date: dateSelected,
                  scope: scope,
                  archived: archived,
                  status: filters
                }}
                kpiType={10}
                fromDeadlines={true}
              />
            ))}
          {customersView === "cashFlow" &&
            FEATURE_TOGGLE_ANALYTICS === "true" &&
            FEATURE_TOGGLE_CASH_FLOW === "true" &&
            classifierCompanySelected !== "PERSON" && (
            <>
              {!showPlaceHolder && !showPlaceholderAfterOrBefore && (
                <div className="analyticsView-chart-customer-deadlines-cashflow-header">
                  <div style={{ alignSelf: "center" }}>
                    <FontAwesomeIcon
                      icon={["far", "sync"]}
                      onClick={() => setModalVisible(true)}
                    />{" "}
                  </div>
                  <div>
                    <div>
                      <span>
                        <FormattedMessage id="analytics.balance" />{" "}
                        <strong>
                          {graph.balance.toLocaleString("it-IT", {
                            minimumFractionDigits: 2
                          })}
                            €
                        </strong>
                      </span>
                    </div>
                    <div>
                      <FormattedMessage id="analytics.lastUpdate" />{" "}
                      {moment().format("DD MMM YYYY [ore] HH:mm")}
                    </div>
                  </div>
                </div>
              )}
              {showPlaceHolder && (
                <div className="analyticsView-chart-customer-deadlines-cashflow-placeholder">
                  <div>
                    <FormattedMessage id="analytics.cashFlowPlaceHolder" />
                  </div>
                  <div>
                    <Button
                      kind="secondary"
                      onClick={() => setModalVisible(true)}
                      size="medium"
                    >
                      <FormattedMessage id="analytics.cashFlowUpgradeBalance" />
                    </Button>
                  </div>
                </div>
              )}

              {showPlaceholderAfterOrBefore && (
                <div className="analyticsView-chart-customer-deadlines-cashflow-placeholder">
                  <div className="alertContainer yellow">
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "flex-start",
                        padding: "20px 0"
                      }}
                    >
                      <FontAwesomeIcon
                        icon={["fas", "exclamation-circle"]}
                        style={{
                          fontSize: "24px",
                          color: "var(--status-warning)",
                          marginRight: "30px"
                        }}
                      />
                      {monthBefore && (
                        <div className="placeHolderMonthText">
                          <strong>
                            <FormattedMessage id={"analytics.attention"} />
                          </strong>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "space-between"
                        }}
                      >
                        <div className="placeHolderMonthText">
                          <FormattedMessage
                            id={
                              monthBefore
                                ? "analytics.visualizeBefore"
                                : "analytics.visualizeAfter"
                            }
                          />
                        </div>
                        <div
                          onClick={() => goToActuallyOrLatestValidMonth()}
                          className="placeHolderMonthText blue"
                        >
                          <FormattedMessage
                            id={
                              monthBefore
                                ? "analytics.selectMonth"
                                : "analytics.goBack"
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {graph.display && !showPlaceholderAfterOrBefore && (
                <AnalyticsChart
                  classChart=""
                  idDivForChart="analyticsView-chart-customer-deadlines-cashflow"
                  kpiName="DeadlinesCashFlow"
                  metamodel={true}
                  addParameter={{
                    date: dateSelected,
                    scope: scope,
                    archived: archived,
                    status: filters,
                    balance: graph.balance
                  }}
                  kpiType={10}
                  fromDeadlines={true}
                />
              )}
              {isModalVisible && (
                <CashFlowModal
                  isModalVisible={isModalVisible}
                  setModalVisible={setModalVisible}
                  setGraph={setGraph}
                  isTsPayEnabled={isTsPayEnabled}
                  setShowPlaceholder={setShowPlaceholder}                  
                />
              )}
            </>
          )}
        </div>

        <div className="boxList">
          <ListDeadlines
            navigate={navigate}
            filterList={filtersList}            
            isSpinner={isGettingDeadlines}
            listDeadlines={filtersList.activeFilters.length === 0 ? deadlinesCompany.subjective : deadlinesAccountant.effectiveOrNot.deadlines}
            resetMonthView={resetMonthView}
            selectedDay={selectedDay}
            setFilterList={setFilterList}
            toggleArchivedDeadline={toggleArchivedDeadline}
            prevPath={prevPath}
            myType={myType}
            companySelected={companySelected}
            deadlinesCompany={deadlinesCompany}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Calendar;
